import * as toastr from 'toastr';
import * as $ from 'jquery';
import 'toastr/build/toastr.css'

const options = {
    positionClass: 'toast-bottom-right',
    target: '.alert-container'
};

const persistOptions = {
    timeOut: 0,
    extendedTimeOut: 0,
    closeButton: true,
    tapToDismiss: false,
    closeDuration: 0
};

export function success(message: string, title?: string, persist: boolean = false, clickHandler: () => void = null): JQuery {
    return toastr.success(message, title,
        $.extend({}, options,
            persist ? persistOptions : {},
            clickHandler ? { onclick: clickHandler } : { }
        ));
}

export function warning(message: string, title?: string, persist: boolean = false, clickHandler: () => void = null) {
    toastr.warning(message, title,
        $.extend({}, options,
            persist ? persistOptions : {},
            clickHandler ? { onclick: clickHandler } : { }
        ));
}

export function error(message: string, title?: string, persist: boolean = false, clickHandler: () => void = null) {
    toastr.error(message, title,
        $.extend({}, options,
            persist ? persistOptions : {},
            clickHandler ? { onclick: clickHandler } : { }
        ));
}

export function clear(toast?: JQuery) {
    // Without force, toastr refuses to clear a focused toast and wipes the whole container instead.
    if (toast)
        toastr.clear(toast, { force: true });
    else
        toastr.clear();
}